export const HOMEPAGE_PAGE_TYPE = 'home';

export const FREQUENTLY_BOUGHT_TOGETHER_PRODUCTS_MIN_NUMBER = 5;
